import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment as env } from "../../../environments/environment";
import { Observable, Subject } from "rxjs";
import { HttpService } from "../../shared/services/http.service";
import { SortType } from "../../shared/models";
import { 
  API_ADMIN_EVENTS, 
  API_ADMIN_EVENTS_GET_TYPES, 
  API_ADMIN_PARTICIPANTS_GET_STATUSES, 
  API_ADMIN_PARTICIPANTS_GET_TYPES 
} from "../../shared/constants/constants";

@Injectable({
  providedIn: "root",
})
export class EventsService {
  private HTTPheaders;
  private optionsResponseTypeBlob;
  private eventSubject = new Subject<any>();

  tableData:Subject<any> = new Subject();

  event$ = this.eventSubject.asObservable();

  emitEvent(data: any) {
    this.eventSubject.next(data);
  }

  constructor(private http: HttpClient, private httpService: HttpService) {
    this.HTTPheaders = {
      "Content-Type": "application/json",
    };
    this.optionsResponseTypeBlob = {
      responseType: "blob" as "json",
    };
  }
  getCollections(
    pagination: {
      page: number,
      perPage: number
    },
    filters: {
      collectionId?: number | null,
      type?: string | null,
    },
    sorting?: SortType
  ): Observable<any> {
    let url = env.baseUrl +
      API_ADMIN_EVENTS +
      "?page=" + pagination.page + "&per_page=" + pagination.perPage;
      url += filters.collectionId ? "&store_like=" + filters.collectionId : "";
      url += filters.type ? "&type_like=" + filters.type : "";
      if (sorting) {
        url += sorting._sort ? "&_sort=" + sorting._sort : "";
        url += sorting._order ? "&_order=" + sorting._order : "";
      }
    return this.http.get<any>(url, this.httpService.getOptions(this.HTTPheaders)
    );
  }

  addNewUser(couponCode: any, registered: boolean) {
    /*let userRow = UserToHide.find(user => user.coupon === couponCode);
    if(userRow) {
      userRow.statusTranslated = registered ? 'statuses.code_activated' : 'statuses.registered';
      this.tempArr.unshift(userRow);
      this.tableData.next([...this.tempArr]);
    }*/
  }

  getCollectionsAll(collectionId?: number): Observable<any> {
    let url = `${env.baseUrl}${API_ADMIN_EVENTS}`;
    url += collectionId ? `?store_like=${collectionId}` : "";
    return this.http.get<any>(url, this.httpService.getOptions(this.HTTPheaders));
  }
  getEvents(
    pagination: {
      page: number,
      perPage: number
    },
    filters: {
      storeId?: number | null,
      type?: string | null,
    },
    sorting?: SortType
  ): Observable<any> {
    let url = env.baseUrl +
      API_ADMIN_EVENTS +
      "?page=" + pagination.page + "&per_page=" + pagination.perPage;
      url += filters.storeId ? "&store_like=" + filters.storeId : "";
      url += filters.type ? "&type_like=" + filters.type : "";
      if (sorting) {
        url += sorting._sort ? "&_sort=" + sorting._sort : "";
        url += sorting._order ? "&_order=" + sorting._order : "";
      }
    return this.http.get<any>(url, this.httpService.getOptions(this.HTTPheaders)
    );
  }

  getEventsAll(storeId?: number): Observable<any> {
    let url = `${env.baseUrl}${API_ADMIN_EVENTS}`;
    url += storeId ? `?store_like=${storeId}` : "";
    return this.http.get<any>(url, this.httpService.getOptions(this.HTTPheaders));
  }

  getEventDetail(token: string, noLoader = false): Observable<any> {
    const params = noLoader ? new HttpParams().set("noLoader", true) : {};

    return this.http.get<any>(`${env.baseUrl}${API_ADMIN_EVENTS}/${token}`, {
      params,
      ...this.httpService.getOptions(this.HTTPheaders),
    });
  }

  getEventTypes() {
    return this.http.get<any>(env.baseUrl + API_ADMIN_EVENTS_GET_TYPES);
  }

  storeEvent(event: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + API_ADMIN_EVENTS, event);
  }

  getParticipantsByEventToken(
    pagination: {
      page: number,
      perPage: number
    } | undefined,
    filters: {
      token: string
      type?: string,
      status?: string,
    },
    sorting?: SortType
  ): Observable<any> {
    let url = env.baseUrl + `${API_ADMIN_EVENTS}/${filters.token}/participants`;
    if (pagination) {
      url += (url.includes("?") ? '&' : '?') + `page=${pagination.page}&per_page=${pagination.perPage}`;
    }
    if (filters.type) {
      if (url.includes("?")) {
        url = url += "&type_like=" + filters.type;
      } else {
        url = url += "?type_like=" + filters.type;
      }
    }
    if (filters.status) {
      if (url.includes("?")) {
        url = url += "&status_like=" + filters.status;
      } else {
        url = url += "?status_like=" + filters.status;
      }
    }
    if (sorting?._sort) {
      if (url.includes("?")) {
        url = url += "&_sort=" + sorting._sort;
      } else {
        url = url += "?_sort=" + sorting._sort;
      }
    }
    if (sorting?._order) {
      if (url.includes("?")) {
        url = url += "&_order=" + sorting._order;
      } else {
        url = url += "?_order=" + sorting._order;
      }
    }
    return this.http.get<any>(url, this.httpService.getOptions(this.HTTPheaders));
  }

  getParticipantsStatuses() {
    return this.http.get<any>(env.baseUrl + API_ADMIN_PARTICIPANTS_GET_STATUSES, this.httpService.getOptions(this.HTTPheaders));
  }

  getParticipantsTypes() {
    return this.http.get<any>(env.baseUrl + API_ADMIN_PARTICIPANTS_GET_TYPES, this.httpService.getOptions(this.HTTPheaders));
  }

  getExportTemplate(token: string) {
    return this.http.get<any>(env.baseUrl + `${API_ADMIN_EVENTS}/${token}/participants/export-template`, this.optionsResponseTypeBlob);
  }

  getExport(token: string, format = 'xlsx') {
    if (token) {
      return this.http.get<any>(env.baseUrl + `${API_ADMIN_EVENTS}/${token}/participants/export?format=${format}`, this.optionsResponseTypeBlob);
    }
    return this.http.get<any>(env.baseUrl + `${API_ADMIN_EVENTS}/export?format=${format}`, this.optionsResponseTypeBlob);
  }

  sendInvites(token: string, body: any) {
    return this.http.put<any>(
      env.baseUrl + `${API_ADMIN_EVENTS}/${token}/send-invitation`,
      body,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  sendPersonInvitesByCsv(token: string, file: File) {
    const formData = new FormData();
    formData.append("csv", file);
    return this.http.post<any>(
      env.baseUrl + `${API_ADMIN_EVENTS}/${token}/participants/import-from-csv`,
      formData
    );
  }

  sendPersonInvites(token: string, body: any) {
    return this.http.post<any>(
      env.baseUrl + `${API_ADMIN_EVENTS}/${token}/participants`,
      body,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  sendInviteToSingleParticipant(token: string, tokenParticipant: string) {
    return this.http.put<any>(
      env.baseUrl +
      `${API_ADMIN_EVENTS}/${token}/participants/${tokenParticipant}/send-invitation`,
      null,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  editParticipant(token: string, tokenParticipant: string, body: any) {
    return this.http.put<any>(
      env.baseUrl + `${API_ADMIN_EVENTS}/${token}/participants/${tokenParticipant}`,
      body,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  editEvent(id: string, body: any) {
    return this.http.put<any>(
      env.baseUrl + `${API_ADMIN_EVENTS}/${id}`,
      body,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  deleteEvent(id: string) {
    return this.http.delete<any>(
      env.baseUrl + `${API_ADMIN_EVENTS}/${id}`,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  deleteParticipant(token: string, tokenParticipant: string) {
    return this.http.delete<any>(
      env.baseUrl + `${API_ADMIN_EVENTS}/${token}/participants/${tokenParticipant}`,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

}
